import { defaultTo } from 'lodash'
import { FieldStatus } from '$domain/model/caretaker/caretaker.model'

const mapPersonalDataStatus = (personalDataStatus: { complete: boolean; userImageStatus: FieldStatus }) => {
  if (!personalDataStatus) {
    return { complete: false, userImageStatus: FieldStatus.unverified }
  }
  return {
    complete: defaultTo(personalDataStatus.complete, false),
    userImageStatus: defaultTo(personalDataStatus.userImageStatus, FieldStatus.unverified),
  }
}

const mapIdentityVerificationStatus = (identityVerificationStatus: { complete: boolean; status: FieldStatus }) => {
  if (!identityVerificationStatus) {
    return { complete: false, status: FieldStatus.unverified }
  }
  return {
    complete: defaultTo(identityVerificationStatus.complete, false),
    status: defaultTo(identityVerificationStatus.status, FieldStatus.unverified),
  }
}

const mapBankDataStatus = bankDataStatus => {
  const mapBankAccountRequirements = bankAccountRequirements => {
    if (bankAccountRequirements) {
      return bankAccountRequirements.eventuallyDue
    }
    return []
  }

  if (!bankDataStatus) {
    return { complete: false, eventuallyDue: [] }
  }
  return {
    complete: defaultTo(bankDataStatus.complete, false),
    eventuallyDue: mapBankAccountRequirements(bankDataStatus.bankAccountRequirements),
  }
}

export const profileModelToFormData = profile => {
  return {
    id: defaultTo(profile.id, ''),
    name: defaultTo(profile.name, ''),
    surname: defaultTo(profile.surname, ''),
    profilePicture: defaultTo(profile.profilePicture, ''),
    caretakerServicesStatus: defaultTo(profile.caretakerServicesStatus, false),
    personalDataStatus: mapPersonalDataStatus(profile.personalDataStatus),
    identityVerificationStatus: mapIdentityVerificationStatus(profile.identityVerificationStatus),
    professionalDataStatus: defaultTo(profile.professionalDataStatus, false),
    bankDataStatus: mapBankDataStatus(profile.bankDataStatus),
    active: defaultTo(profile.active, false),
    firstTimeComplete: defaultTo(profile.firstTimeComplete, false),
    isVerified: defaultTo(profile.isVerified, false),
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretaker.mapper.ts